<div class="home-search-cta-banner-input">
    <div class="search-container">
        <form [formGroup]="formGroup">
            <mat-form-field>
                <button
                    matPrefix
                    class="search"
                    (click)="handleSearch($event)"
                    matTooltip="Search"
                    [matTooltipShowDelay]="1000"
                    [matTooltipHideDelay]="1000"
                    [attr.data-analytics]="'search-icon'">
                    <mat-icon [svgIcon]="'search'" aria-hidden></mat-icon>
                </button>
                <input
                    #searchTermRef
                    type="text"
                    matInput
                    formControlName="query"
                    [placeholder]="(isMobile$ | async) ? 'Search' : 'What are you looking for?'"
                    (keydown.enter)="handleSearch($event)"
                    (keyup)="keyup($event)"
                    (focus)="onFocus()"
                    (keydown.arrowup)="arrowUp($event)"
                    (keydown.arrowdown)="arrowDown($event)"
                    matTooltip="Search"
                    [matTooltipShowDelay]="1000"
                    [matTooltipHideDelay]="1000"
                    [attr.data-analytics]="'search-bar'" />
                <div class="suffix" [ngClass]="{ visible: formGroup.controls.query.value != '' }">
                    <!-- the normal `matSuffix` directive is insufficient for multiple icons with a divider -->
                    <button
                        class="clear"
                        (click)="handleClear($event)"
                        matTooltip="Clear search"
                        [matTooltipShowDelay]="1000"
                        [matTooltipHideDelay]="2000"
                        [attr.data-analytics]="'clear-icon'">
                        <mat-icon [svgIcon]="'close'" aria-hidden></mat-icon>
                    </button>
                </div>
            </mat-form-field>
        </form>
        <!--TODO: Refactor. Try to use Coveo suggestions-->
        <ng-container *ngIf="suggestions$ | async as suggestions">
            <div class="suggestions" *ngIf="suggestions.length > 1 && !showSuggestionContainer">
                @for (s of suggestions | slice: 0 : 5; track s.expression; let i = $index) {
                    <button
                        (click)="searchSuggestion(s)"
                        matTooltip="Click to search"
                        [matTooltipShowDelay]="1000"
                        [matTooltipHideDelay]="2000"
                        [ngClass]="{ 'active-suggestion': (suggestionIndex$ | async) == i }"
                        [innerHtml]="s | appHomeSearchCtaBannerInputMask">
                    </button>
                }
            </div>
        </ng-container>

        <app-search-suggestions [isVisible]="showSuggestionContainer" (closePanel)="closeSuggestions()">
        </app-search-suggestions>
    </div>
</div>
